var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import authentication from "@irati/auth";
import UsersForBusiness, { userList } from "@irati/identity/apollo/query/UsersForBusiness";
import FormattedMessage from "@irati/utils/lang";
import AdminHeader from "./AdminHeader";
var COUNT_VARIABLES = function () { return ({
    includeBusiness: false,
    totalOnly: true,
    enabled: true,
    businessId: authentication.userTenant().uuid,
    teamId: null
}); };
var BusinessAdminHeader = /** @class */ (function (_super) {
    __extends(BusinessAdminHeader, _super);
    function BusinessAdminHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** @description: Fallback function until `<UsersForBusiness />` Query component mounts */
        _this.refetch = function () { };
        return _this;
    }
    BusinessAdminHeader.prototype.render = function () {
        var _this = this;
        var children = this.props.children;
        return (React.createElement(UsersForBusiness, { variables: COUNT_VARIABLES(), useError: false }, function (apollo) {
            _this.refetch = apollo.refetch;
            var total = userList(apollo).total;
            return (React.createElement(AdminHeader, { title: React.createElement(FormattedMessage, { id: "admin.containers.manageUsers.nameCountAndButton.title" }), count: total > 0 ? React.createElement(FormattedMessage, { id: "admin.containers.manageUsers.nameCountAndButton.count", values: { total: total } }) : undefined }, children));
        }));
    };
    return BusinessAdminHeader;
}(PureComponent));
export default BusinessAdminHeader;
